const siteHeader = document.querySelector('.site-header')
// Check if window is scrolled by at least 8x
const scrollCheck = () => {
    if (document.documentElement.classList.contains('stay-dark')) return
    if (window.scrollY > 8) {
        // add class to html element
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
    }
}
// Listen for scroll events
window.addEventListener('scroll', scrollCheck)
// Run scrollCheck on load
scrollCheck()
